import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { Toaster } from "./components/ui/sonner";
import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import Onboarding from "./pages/Onboarding";
import Demo from "./pages/Demo";
import Legal from "./pages/Legal";
import MentionsLegales from "./pages/MentionsLegales";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import CGU from "./pages/CGU";
import Roadmap from "./pages/Roadmap";
import NotFound from "./pages/NotFound";
import CookieBanner from "./components/CookieBanner";
import BillingSuccess from "./pages/BillingSuccess";
import BillingCancel from "./pages/BillingCancel";
import DashboardLayout from "./components/DashboardLayout";
import Dashboard from "./pages/app/Dashboard";
import Workflows from "./pages/app/Workflows";
import WorkflowEditor from "./pages/app/WorkflowEditor";
import WorkflowDetail from "./pages/app/WorkflowDetail";
import Analytics from "./pages/app/Analytics";
import Integrations from "./pages/app/Integrations";
import Marketplace from "./pages/app/Marketplace";
import WhatsAppConfig from "./pages/app/WhatsAppConfig";
import Team from "./pages/app/Team";
import Settings from "./pages/app/Settings";
import Admin from "./pages/app/Admin";
import ProtectedRoute from "./components/ProtectedRoute";
import "./App.css";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/demo" element={<Demo />} />
            <Route path="/legal" element={<Legal />} />
            <Route path="/mentions-legales" element={<MentionsLegales />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/cgu" element={<CGU />} />
            <Route path="/roadmap" element={<Roadmap />} />
            <Route path="/billing/success" element={<ProtectedRoute><BillingSuccess /></ProtectedRoute>} />
            <Route path="/billing/cancel" element={<BillingCancel />} />
            <Route path="/onboarding" element={<ProtectedRoute><Onboarding /></ProtectedRoute>} />

            <Route path="/app" element={<DashboardLayout />}>
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="workflows" element={<Workflows />} />
              <Route path="workflows/new" element={<WorkflowEditor />} />
              <Route path="workflows/:id" element={<WorkflowDetail />} />
              <Route path="workflows/:id/edit" element={<WorkflowEditor />} />
              <Route path="analytics" element={<Analytics />} />
              <Route path="integrations" element={<Integrations />} />
              <Route path="marketplace" element={<Marketplace />} />
              <Route path="whatsapp" element={<WhatsAppConfig />} />
              <Route path="team" element={<Team />} />
              <Route path="settings" element={<Settings />} />
              <Route path="admin" element={<Admin />} />
            </Route>

            <Route path="*" element={<NotFound />} />
          </Routes>
          <CookieBanner />
        </BrowserRouter>
        <Toaster position="top-right" />
      </AuthProvider>
    </div>
  );
}

export default App;
